import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useDashboardAnalytics = (
  userID,
  dashboardInterval,
  campaignInterval,
  platform,
  {
    enableDashboard = true,
    enableCampaignAnalytics = true,
    enableOrderAnalytics = true,
    enableBestSelling = true,
    enableRestaurantAnalytics = true,
  } = {},
  refreshKey = 0
) => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [dashboardData, setDashboardData] = useState({});
  const [campaignAnalytics, setCampaignAnalytics] = useState([]);
  const [orderAnalytics, setOrderAnalytics] = useState([]);
  const [topOrders, setTopOrders] = useState([]);
  const [topOrdersAnalytics, setTopOrdersAnalytics] = useState([]);
  const [restaurantAnalytics, setRestaurantAnalytics] = useState([]);

  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [campaignLoading, setCampaignLoading] = useState(false);

  const fetchDashboardAnalytics = async () => {
    try {
      setDashboardLoading(true);

      const res = await axios.post(
        `${baseUrl}/Whatsapp/getDashboardAnalytics`,
        {
          userid: userID,
          interval: dashboardInterval,
        },
        config
      );

      if (res?.data?.responseCode === "00") {
        setDashboardData(res.data.data || {});
      }
    } catch (err) {
      console.error("Dashboard API Error:", err);
    } finally {
      setDashboardLoading(false);
    }
  };

  const fetchCampaignAnalytics = async () => {
    try {
      setCampaignLoading(true);

      const res = await axios.post(
        `${baseUrl}/Admin/getCampaignAnalyticsAdmin`,
        {
          userid: userID,
          duration: campaignInterval,
        },
        config
      );

      if (res?.data?.responseCode === "00") {
        setCampaignAnalytics(res.data.response || []);
      }
    } catch (err) {
      console.error("Campaign Analytics API Error:", err);
    } finally {
      setCampaignLoading(false);
    }
  };

  useEffect(() => {
    if (!userID || !enableDashboard) return;
    fetchDashboardAnalytics();
  }, [userID, dashboardInterval, refreshKey]);

  useEffect(() => {
    if (!userID || !enableCampaignAnalytics) return;
    fetchCampaignAnalytics();
  }, [userID, campaignInterval, refreshKey]);

  return {
    dashboardData,
    campaignAnalytics,
    orderAnalytics,
    topOrders,
    topOrdersAnalytics,
    restaurantAnalytics,
    dashboardLoading,
    campaignLoading,
  };
};

export default useDashboardAnalytics;